import { LoadableAfterPaint, MustPreloadLoadableNames } from '@confluence/loadable';

const RendererLoader = LoadableAfterPaint({
	// Name needs to match the one in next/packages/view-page/src/index.ts
	name: MustPreloadLoadableNames.ClassicRendererLoader,
	loader: () => import(/* webpackChunkName: "loadable-RendererQuery" */ './Renderer.tsx'),
});

export default RendererLoader;
